import VideoPlayer from '../shared/videoPlayer';
import { setCookie, getCookie } from '../shared/cookieHelper';
import LockCollateralStatusSignalR from '../shared/lockCollateralStatusSignalR';
import { createUnitToggle } from '../shared/unitToggle';
import {
    SellerConcessionUnit,
    SellerConcessionStatus,
    MinSellerConcessionPercent,
    MaxSellerConcessionPercent,
    evaluateConcessionEntry,
    convertConcessionToDollars,
    convertConcessionToPercent,
    parseNumber
} from '../shared/concessionUnits';

const listNLockVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#locknlist_confirmation_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var form = new FormData();
            form.append("loan-number", $("#loan-number").val());

            // Certificate is Lock Now ONLY (spec Section 9).
            // The view only renders #certlink for Lock Now (guarded by !isLockLater in Razor).
            // Only fire the AJAX if #certlink is present — skips the 16s certificate call on LLConfirmation pages.
            if ($('#certlink').length) {
                $.ajax({
                    url: 'generate-certificate-confirmation',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                        if (response != "") {
                            // Server now returns a download-ready URL with fl_attachment flag
                            $("#certlink").attr("href", response).removeClass("disabled");
                        } else {
                            // Empty response indicates cert generation hard-failed server-side (e.g. missing
                            // OpenFlyerUrl with no address to self-heal from, or Cloudinary 400). Leave the
                            // button disabled but update its label so the user sees an actionable state.
                            console.warn("Certificate generation returned empty response");
                            $("#certlink").text("Certificate unavailable").attr("title", "Unable to generate certificate. Please contact support.");
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error("Certificate generation failed:", textStatus, errorThrown);
                        $("#certlink").text("Certificate generation failed").attr("title", "Certificate generation error. Please refresh to retry.");
                    }
                });
            }

            var loc1 = $("#prefixurl").val();

            // QR Code Image: two-state logic driven by server-rendered data attributes.
            // data-cached-qr-url: the existing Cloudinary URL (empty if none yet)
            // data-qr-regenerating: "true" when the server started a background QR regen (always true for LLConfirmation)
            //
            // State 1 — ready (not regenerating): image already rendered server-side, no JS action needed
            // State 2 — regenerating in background: spinner shown; SignalR 'qr_code' event swaps in real image
            var $qrImg = $("#qr-img");
            var qrRegenerating = $qrImg.data("qr-regenerating") === true;
            // No AJAX fallback for QR — background Task.Run A always runs; SignalR will deliver the result

            // Open House Flyer: three-state logic driven by server-rendered data attributes.
            // data-cached-flyer-url: the existing Cloudinary PDF URL (empty if none yet)
            // data-flyer-regenerating: "true" when the server started a background PDF regen
            //
            // State 1 — cached and current: display immediately, no AJAX
            // State 2 — regenerating in background: show spinner; SignalR DocumentReady event auto-updates UI when done
            // State 3 — no cached URL and not regenerating (fallback): fire AJAX as last resort
            var $openimg = $("#openimg");
            var cachedFlyerUrl = $openimg.data("cached-flyer-url");
            var flyerRegenerating = $openimg.data("flyer-regenerating") === true;

            if (cachedFlyerUrl && !flyerRegenerating) {
                // State 1: cached URL is current — display it immediately, no AJAX needed
                var cacheBuster = new Date().getTime();
                $("#openimg").attr("src", cachedFlyerUrl.replace(".pdf", ".png") + "?cb=" + cacheBuster);
                // Use same-origin proxy for download so browser triggers Save-As instead of navigating.
                var flyerProxyUrl = loc1 + '/download-file?url=' + encodeURIComponent(cachedFlyerUrl) + '&filename=OpenHouseFlyer';
                $("#openlink").attr("href", flyerProxyUrl).removeClass("disabled").css('pointer-events', '');
            } else if (flyerRegenerating) {
                // State 2: rates refreshed today — server is regenerating the flyer in background.
                // The cached flyer contains stale rates and MUST NOT be shown or made downloadable.
                // Server already rendered #flyer-placeholder (loading gif div) in Razor — keep it visible.
                // SignalR DocumentReady handler will hide #flyer-placeholder and show #openimg when done.
                // Do NOT fire generate-flyer-confirmation AJAX — the server background task is already running.
                $("#openimg").hide();
                $("#openlink").addClass("disabled").attr("href", "javascript:void(0)");
            } else {
                // State 3: no cached URL and not regenerating — fire AJAX as last-resort fallback
                $("#openlink").addClass("disabled").attr("href", "javascript:void(0)");
                $.ajax({
                    url: 'generate-flyer-confirmation',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $("#openimg").attr("src", "https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif");
                    },
                    success: function (response) {
                        if (response != "") {
                            var cacheBuster = new Date().getTime();
                            var flyerPreviewUrl = response.replace(".pdf", ".png") + "?cb=" + cacheBuster;
                            $("#openimg").attr("src", flyerPreviewUrl);
                            // Use same-origin proxy for download
                            var flyerAjaxProxyUrl = loc1 + '/download-file?url=' + encodeURIComponent(response) + '&filename=OpenHouseFlyer';
                            $("#openlink").attr("href", flyerAjaxProxyUrl).removeClass("disabled").css('pointer-events', '');
                        } else {
                            console.warn("OHF generation returned empty response");
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error("OHF generation failed:", textStatus, errorThrown);
                        $("#openimg").attr("src", "");
                    }
                });
            }

            function PostData(url, data) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#instructions-div p').removeClass('upload-error');
                        $('#instructions-social-div p').removeClass('upload-error');

                        $('[download="CustomVideo"], [download="VideoQRCode"]').parent().addClass('d-none');
                        $('#instructions-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-div').removeClass('d-none');

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').addClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').removeClass('d-none');

                        $('[download="SocialVideo"]').parent().addClass('d-none');
                        $('#instructions-social-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social-div').removeClass('d-none');

                        $('#social_video_placeholder, #social_video').addClass('d-none');
                        $('#social_video_loading').removeClass('d-none');

                        $('[download="SocialAdVideo"]').parent().addClass('d-none');
                        $('#instructions-social_ad-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social_ad-div').removeClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').addClass('d-none');
                        $('#social_ad_video_loading').removeClass('d-none');

                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            // FIX: Update listing image IMMEDIATELY with the new URL from server response
                            // This ensures user sees new image before page reload, avoiding cached image display
                            if (result.listingImageUrl && result.listingImageVersion) {
                                var freshImageUrl = result.listingImageUrl;

                                // Ensure _final version (with badge overlay)
                                if (!freshImageUrl.includes('_final')) {
                                    var lastDot = freshImageUrl.lastIndexOf('.');
                                    if (lastDot > 0) {
                                        freshImageUrl = freshImageUrl.substring(0, lastDot) + '_final' + freshImageUrl.substring(lastDot);
                                    }
                                }

                                // Add cache-busting parameter
                                freshImageUrl += '?v=' + result.listingImageVersion;

                                // Update image immediately
                                $('#listing_image').prop('src', freshImageUrl);

                            }

                            // Handle video generation status - new response format from server
                            if (result.videoGenerationStatus === 'pending') {
                                // Show warning but still reload to display the new listing image
                                $('#instructions-div p').text('Listing image uploaded successfully! Some videos are still generating and will be available shortly.').removeClass('upload-error').addClass('upload-warning');
                                $('#instructions-social-div p').text('Some videos are still generating and will be available shortly.').removeClass('upload-error').addClass('upload-warning');
                            }

                            // Add 1.5 second delay before reload to allow:
                            // 1. Database transaction to fully commit
                            // 2. Entity Framework cache to clear
                            // 3. Rate service to stabilize after potential concurrent requests
                            setTimeout(function() {
                                // Match Builder Spec Lock pattern: add videos_generating flag to reconnect SignalR after reload
                                var currentUrl = new URL(window.location.href);

                                // Only add videos_generating flag - preserve existing id parameter
                                currentUrl.searchParams.set('videos_generating', 'true');

                                window.location.href = currentUrl.toString();
                            }, 1500);

                            return;
                        }

                        // Fix 4: Improved error messages - show specific error from server and differentiate between upload and video errors
                        var errorMessage = result.error || 'Unable to generate customized video. Please try again.';

                        // Check if error is video-related but listing image was saved
                        if (errorMessage.toLowerCase().includes('video') && !errorMessage.toLowerCase().includes('upload')) {
                            $('#instructions-div p').text('Listing image saved successfully! Videos are being regenerated and will be available shortly.').addClass('upload-warning');
                            $('#instructions-social-div p').text('Videos are being regenerated and will be available shortly.').addClass('upload-warning');
                        } else {
                            $('#instructions-div p').text(errorMessage).addClass('upload-error');
                            $('#instructions-social-div p').text(errorMessage.replace('customized video', 'social video')).addClass('upload-error');
                        }

                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video').removeClass('d-none');
                        $('#property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        // Only show #property_video_qr if a src has been set (i.e. QR URL arrived via SignalR)
                        if (!$('#property_video_qr').attr('src')) { $('#property_video_qr').addClass('d-none'); }
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    },
                    error: function (xhr, status, error) {
                        console.error("Listing image upload failed. Status: " + status + ' error: ' + error);

                        if (xhr.status === 504) {
                            location.reload();
                            return;
                        }

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video').removeClass('d-none');
                        $('#property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        // Only show #property_video_qr if a src has been set (i.e. QR URL arrived via SignalR)
                        if (!$('#property_video_qr').attr('src')) { $('#property_video_qr').addClass('d-none'); }
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    }
                });
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            $('#attach-input').on('change', async function (e) {
                var data = new FormData();
                data.append("loan-number", $("#hdnConfirmationNumber").val());

                var files = e.target.files;
                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                try {
                    // SOLUTION 1: Ensure SignalR is ready with handlers BEFORE upload
                    if (!videoStatusHub) {
                        createVideoSignalR();
                    }

                    if (!handlersRegistered) {
                        registerVideoHandlers();
                    }

                    if (!videoStatusHub.isConnected()) {
                        await initializeVideoSignalRConnection();
                    }
                } catch (error) {
                    console.error('Failed to initialize SignalR before upload:', error);
                }

                PostData(window.location.origin + window.location.pathname + '/upload-listing-image', data);
            })

            $('#new_sales_price').on('focus', function (e) {
                if ($(this).val() === '$0') {
                    $(this).val('');
                }
            });

            $('#new_sales_price').on('keyup change', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var filteredValue = $(this).val().replace(/\D/g, '');
                if (!filteredValue) {
                    $(this).val('$0');
                    return;
                }

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));
                var newValue = Number(filteredValue);
                $(this).val(newValue.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

                if (Math.abs(1 - newValue / curValue) < 0.25) {
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#new_sales_price').on('blur', function (e) {
                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var newValue = Number($('#new_sales_price').val().replace(/\D/g, ''));
                if (newValue == 0)
                    return;

                var curValue = Number($('#current_sales_price').val().replace(/\D/g, ''));

                if (Math.abs(1 - newValue / curValue) > 0.25) {
                    $('#price_error_message').removeClass('d-none');
                    $('#update_price').prop("disabled", true);
                }
                else {
                    $('#price_error_message').addClass('d-none');
                    $('#update_price').prop("disabled", false);
                }
            });

            $('#update_price, #revert_original_price').on('click', function (e) {
                $('#price_change_form').parent().addClass('d-none');
                $('#loading-img-price').removeClass('d-none');

                $('#update_price_error_message').addClass('d-none');
                $('#no_rates_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                var postUrl = $(this).attr('id') == 'update_price'
                    ? `update-price?loanNumber=${confirmationNumber}&newPrice=${Number($('#new_sales_price').val().replace(/\D/g, ''))}`
                    : `update-price?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function () {
                        location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        // Check for structured error response with user-friendly message
                        if (jqXHR.status === 500 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'rates_unavailable') {
                            // Display user-friendly message for rates unavailable
                            var errorMessageElement = $('#update_price_error_message');
                            errorMessageElement.text(jqXHR.responseJSON.userMessage || 'Unable to calculate updated rates. Please contact your loan officer.');
                            errorMessageElement.removeClass('d-none');
                            errorMessageElement.removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            // Generic error for other failures
                            $('#update_price_error_message').removeClass('d-none');
                        }

                        $('#price_change_form').parent().removeClass('d-none');
                        $('#loading-img-price').addClass('d-none');
                    });
            });

            // ---- Update Property Address — Lock Later only (issue #255) -----------
            // The server re-validates every field (EvaluatePropertyAddressUpdate); this check
            // only saves a round trip. Values go in the POST body, not the query string, so
            // jQuery encodes characters like #, & and ' instead of corrupting the request.
            $('#update_property_address').on('click', function () {
                var address = {
                    loanNumber: $('#hdnConfirmationNumber').val(),
                    streetNumber: $.trim($('#new_streetnumber').val()),
                    streetName: $.trim($('#new_streetname').val()),
                    street2: $.trim($('#new_street2').val()),
                    city: $.trim($('#new_city').val()),
                    zipCode: $.trim($('#new_zipcode').val()),
                    countyCode: $.trim($('#new_county').val())
                };

                $('#property_address_error_message').addClass('d-none');
                $('#property_address_update_error_message').addClass('d-none');

                if (!address.streetNumber || !address.streetName || !address.city || !address.zipCode || !address.countyCode) {
                    $('#property_address_error_message').removeClass('d-none');
                    return;
                }

                $('#property_address_change_form').parent().addClass('d-none');
                $('#loading-img-street-change').removeClass('d-none');

                $.post('update-property-address', address)
                    .done(function () {
                        location.reload();
                    })
                    .fail(function (jqXHR) {
                        if (jqXHR.status === 400 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'invalid_address') {
                            $('#property_address_error_message').removeClass('d-none');
                        } else {
                            $('#property_address_update_error_message').removeClass('d-none');
                        }

                        $('#property_address_change_form').parent().removeClass('d-none');
                        $('#loading-img-street-change').addClass('d-none');
                    });
            });

            // ---- Seller concession: $ / % entry (issue #240) ----------------------
            //
            // The conversion base is the CURRENT sales price, matching both the field
            // rendered above and the value UpdateSellerConcession passes to the rate
            // service. It is fixed for the life of the page — this form cannot change
            // the sales price, so unlike the Search Rate Options page there is no
            // anchoring to maintain: the entry is simply re-read in whichever unit is
            // selected.
            var concessionBase = parseNumber($('#current_sales_price').val());

            // Same {value, anchor} shape as the Search Rate Options page: the number the
            // user last TYPED, held in the unit they typed it in. The displayed figure is
            // derived from it and never read back as truth.
            //
            // Caching the last *valid percentage* instead was a real defect: typing 18000
            // ($, base 300000) cached 6, then editing to 20000 (invalid) left the cache at
            // 6, and toggling to % overwrote the user's 20000 with 6 — clearing the error
            // and enabling the Update button. The entry must survive its own invalidity.
            var concession = { anchor: SellerConcessionUnit.Dollar, value: null };

            function concessionUnit() {
                return concessionToggle ? concessionToggle.getUnit() : SellerConcessionUnit.Percent;
            }

            function evaluateConcession() {
                return evaluateConcessionEntry($('#new_concession').val(), concessionUnit(), concessionBase);
            }

            function showConcessionError(message) {
                $('#concession_error_message').text(message).removeClass('d-none');
            }

            function applyConcessionState(result, showErrors) {
                $('#concession_update_error_message').addClass('d-none');
                $('#concession_error_message').addClass('d-none');

                var usable = result.status === SellerConcessionStatus.Valid;
                $('#update_seller_concession').prop('disabled', !usable);

                if (usable) {
                    return;
                }

                // An empty field disables the button silently. Previously Number('')
                // was 0, so clearing the box flashed the bounds error immediately;
                // parseNumber returns null instead, which lets the error wait for blur.
                if (!showErrors || result.status === SellerConcessionStatus.Missing) {
                    return;
                }

                showConcessionError(result.message
                    || 'Seller concession should be within ' + MinSellerConcessionPercent
                       + '-' + MaxSellerConcessionPercent + '% range.');
            }

            // Native constraints follow the selected unit. step is not cosmetic: a
            // type="number" input with the default step="1" marks a converted value
            // like 5.67 invalid at the browser level.
            function applyConcessionConstraints(unit) {
                var $input = $('#new_concession');
                var isDollar = unit === SellerConcessionUnit.Dollar;

                var min = isDollar
                    ? convertConcessionToDollars(MinSellerConcessionPercent, concessionBase)
                    : MinSellerConcessionPercent;
                var max = isDollar
                    ? convertConcessionToDollars(MaxSellerConcessionPercent, concessionBase)
                    : MaxSellerConcessionPercent;

                $input.attr({ min: min, max: max, step: isDollar ? '1' : '0.01' });
                $input.toggleClass('icon-left', isDollar).toggleClass('icon-right', !isDollar);

                $('#new_concession_label').text(isDollar
                    ? 'New Concession ($)'
                    : 'New Concession (' + MinSellerConcessionPercent + '-' + MaxSellerConcessionPercent + '%)');
            }

            // The entered value expressed in a given unit, or null when it cannot be.
            function concessionIn(unit) {
                if (concession.value === null) {
                    return null;
                }

                if (unit === concession.anchor) {
                    return concession.value;
                }

                return unit === SellerConcessionUnit.Dollar
                    ? convertConcessionToDollars(concession.value, concessionBase)
                    : convertConcessionToPercent(concession.value, concessionBase);
            }

            var concessionToggle = createUnitToggle(document.getElementById('concession_unit_toggle'), {
                onChange: function (unit) {
                    // Rewrite the field FROM the anchored entry, not from whatever text
                    // is on screen and not from a cached "last valid" figure. The display
                    // is a projection, which is what makes repeated toggling idempotent
                    // instead of accumulating rounding drift — and what stops an invalid
                    // entry from being silently replaced by an older valid one.
                    applyConcessionConstraints(unit);

                    var converted = concessionIn(unit);

                    // Refuse to write a null — below the conversion floor there is
                    // nothing to show, and blanking the field would lose the entry.
                    if (converted !== null) {
                        $('#new_concession').val(converted);
                    }

                    // Re-validate in the NEW unit and show the result. AC-13 requires the
                    // error to be re-evaluated in both directions: a value that is fine in
                    // one unit can breach the bound in the other, and an error raised
                    // before the toggle must not survive into a unit where it no longer
                    // applies.
                    applyConcessionState(evaluateConcession(), true);
                }
            });

            if (concessionToggle) {
                applyConcessionConstraints(concessionToggle.getUnit());
            }

            // Bounds are checked as you type so the button state tracks the field, but
            // the error text is held back until blur or change — errors while typing
            // fire on every intermediate keystroke ("1" on the way to "18000").
            // The ONLY place the anchor is written. Typing re-anchors; nothing else may —
            // that single restriction is what makes toggling non-destructive.
            $('#new_concession').on('input', function () {
                concession.anchor = concessionUnit();
                concession.value = parseNumber($(this).val());
            });

            $('#new_concession').on('keyup', function () {
                applyConcessionState(evaluateConcession(), false);
            });

            $('#new_concession').on('change blur', function () {
                applyConcessionState(evaluateConcession(), true);
            });

            $('#revert_seller_concession, #update_seller_concession').on('click', function (e) {
                $('#concession_change_form').parent().addClass('d-none');
                $('#loading-img-seller-concession').removeClass('d-none');

                $('#concession_error_message').addClass('d-none');
                $('#concession_update_error_message').addClass('d-none');

                var confirmationNumber = $('#hdnConfirmationNumber').val();

                // Always post the canonical PERCENTAGE, whichever unit is on screen —
                // the endpoint's parameter is a percent and the column stores one.
                // Re-evaluate rather than trusting the cached value so a submission can
                // never carry a figure the field no longer shows.
                //
                // The revert branch deliberately posts NO newConcession at all: a null
                // concession is what "Revert to Original Concession" means to the
                // server, and appending an empty value here would turn a revert into a
                // rejected update.
                var submitted = evaluateConcession();
                var isUpdate = $(this).attr('id') == 'update_seller_concession';

                // Fail closed. The Update button is disabled while the entry is invalid,
                // so this is defence in depth — but posting submitted.percent when the
                // seam did not accept the entry would send a 0.
                if (isUpdate && !submitted.isValid) {
                    $('#concession_change_form').parent().removeClass('d-none');
                    $('#loading-img-seller-concession').addClass('d-none');
                    applyConcessionState(submitted, true);
                    return;
                }

                var postUrl = $(this).attr('id') == 'update_seller_concession'
                    ? `update-seller-concession?loanNumber=${confirmationNumber}&newConcession=${submitted.percent}`
                    : `update-seller-concession?loanNumber=${confirmationNumber}`;

                $.post(postUrl)
                    .done(function (data, textStatus, jqXHR) {
                            location.reload();
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        // Check for structured error response with user-friendly message
                        if (jqXHR.status === 500 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'rates_unavailable') {
                            // Display user-friendly message for rates unavailable
                            var errorMessageElement = $('#concession_update_error_message');
                            errorMessageElement.text(jqXHR.responseJSON.userMessage || 'Unable to calculate updated rates. Please contact your loan officer.');
                            errorMessageElement.removeClass('d-none');
                            errorMessageElement.removeClass('alert-danger').addClass('alert-warning');
                        } else if (jqXHR.status === 400 && jqXHR.responseJSON && jqXHR.responseJSON.error === 'concession_out_of_range') {
                            // The server rejected a bound the client should have caught, so this
                            // fires only when the client half was bypassed (stale bundle, crafted
                            // request). Surface it on the field's own error line rather than the
                            // generic "something went wrong" — the value is fixable.
                            $('#concession_change_form').parent().removeClass('d-none');
                            $('#loading-img-seller-concession').addClass('d-none');
                            showConcessionError(jqXHR.responseJSON.userMessage
                                || 'Seller concession should be within 1-6% range.');
                            return;
                        } else if (jqXHR.status === 0 || jqXHR.status === 502 || jqXHR.status === 503 || jqXHR.status === 504 || textStatus === 'timeout') {
                            // Server timeout — data may have been saved successfully
                            var errorMessageElement = $('#concession_update_error_message');
                            errorMessageElement.text('The update is taking longer than expected. Your changes may have been saved \u2014 please refresh the page to check.');
                            errorMessageElement.removeClass('d-none');
                            errorMessageElement.removeClass('alert-danger').addClass('alert-warning');
                        } else {
                            // Generic error for other failures
                            $('#concession_update_error_message').removeClass('d-none');
                        }

                        $('#concession_change_form').parent().removeClass('d-none');
                        $('#loading-img-seller-concession').addClass('d-none');
                    });
            });

            $('[data-programs] input').on('change', function (e) {

                var $programCheckbox = $(this);
                                               
                if ($programCheckbox.is('[program-change-popup]') && $programCheckbox.prop('checked')) {
                    
                    var programCode = $programCheckbox.val();
                    $('#program_change_dialog #title').text(`Are you sure that this property is ${programCode} enabled?`);

                    $('#program_change_dialog #cancel_program_change').on('click', function (e) {
                        $programCheckbox.prop('checked', false);
                        $('#program_change_dialog').removeClass('show');                        
                    })

                    $('#program_change_dialog #confirm_program_change').on('click', function (e) {                        
                        $('#update_programs').prop('disabled', false);
                        $('#program_change_dialog').removeClass('show');
                    })

                    $('#program_change_dialog').addClass('show');
                }
                else {
                    $('#update_programs').prop('disabled', false);
                    $('#update_programs_error_message').removeClass('d-none');
                }
            });

            $('#update_programs').on('click', function (e) {
                $('#loading-img-programs').removeClass('d-none');
                $('#update_programs_error_message').addClass('d-none');
                $('[data-programs]').parent().addClass('d-none');

                var programList = [];
                $('[data-programs] input:checked').each(function () {
                    programList.push($(this).val());
                });

                var confirmation = $('#hdnConfirmationNumber').val();

                var cPathName = location.pathname;
                if (cPathName.indexOf("ll-confirmation") > 0)
                    cPathName = cPathName.replace('ll-confirmation', 'update-program-list?confirmationNumber=');
                else
                    cPathName = cPathName.replace('confirmation', 'update-program-list?confirmationNumber=');

                $.ajax({
                    url: location.origin + cPathName + confirmation,
                    type: 'POST',
                    contentType: 'application/json', 
                    data: JSON.stringify(programList.join(',')),
                    success: function (response) {
                        location.reload();
                    }
                }).done(function (data, textStatus, jqXHR) {
                    location.reload();
                })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $('#update_programs_error_message').removeClass('d-none');
                        $('#loading-img-programs').addClass('d-none');
                        $('[data-programs]').parent().removeClass('d-none');
                    });
            });

            // Initialize SignalR for video status updates
            var videoStatusHub = null;
            var confirmationNumber = $('#hdnConfirmationNumber').val();
            var handlersRegistered = false;

            // Helper function to create SignalR instance (but not initialize connection yet)
            function createVideoSignalR() {
                if (!videoStatusHub) {
                    videoStatusHub = new LockCollateralStatusSignalR(confirmationNumber, listNLockVideoGenerationTimeout);
                }
                return videoStatusHub;
            }

            // Helper function to initialize SignalR connection (call AFTER handlers registered)
            async function initializeVideoSignalRConnection() {
                if (videoStatusHub && !videoStatusHub.isConnected()) {
                    await videoStatusHub.initialize();
                }
                return videoStatusHub;
            }

            // Helper function to register all video handlers
            function registerVideoHandlers() {
                if (handlersRegistered) {
                    return;
                }

                // Register property video handler if pending
                if ($('#property_video').is('.pending')) {
                    // Register property/custom video handler
                    // NOTE: Changed from 'custom' to 'property' to match server SignalR notification
                    videoStatusHub.registerVideoHandler(
                        'property',
                        // On success
                        function(data) {
                            // Validate data before updating UI (check for ERROR prefix)
                            if (!data.videoUrl || !data.thumbnailUrl) {
                                console.warn('Property video data incomplete:', data);
                                $('#property_video_loading').addClass('d-none');
                                $('#instructions-div').removeClass('d-none');
                                $('#instructions-div p').text('Video is still processing. Please refresh the page in a moment.').addClass('upload-info');
                                return;
                            }

                            // Check for ERROR strings in URLs
                            if (data.videoUrl.startsWith('ERROR:') || data.thumbnailUrl.startsWith('ERROR:')) {
                                console.error('Property video generation failed:', data);
                                $('#property_video_loading').addClass('d-none');
                                $('#instructions-div').removeClass('d-none');
                                $('#instructions-div p').text('Video generation encountered an error. Please contact support.').addClass('upload-error');
                                $('#property_video').removeClass('pending');
                                return;
                            }

                            // Update UI directly from SignalR data - no AJAX call needed!
                            var $thumbnail = $('#property_video [data-role="thumbnail"]');
                            $thumbnail.attr('data-src', data.thumbnailUrl);
                            $thumbnail.css('background-image', 'url("' + data.thumbnailUrl + '")');

                            $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                            $('#property_video').removeClass('pending');
                            $('#property_video_loading').addClass('d-none');

                            // Set download URL if provided
                            if (data.downloadUrl) {
                                $('[download="CustomVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                                $('[download="CustomVideo"]').parent().removeClass('d-none');
                            }

                            new VideoPlayer();

                            // Set QR code URL if provided
                            if (data.qrCodeUrl) {
                                $('#property_video_qr').attr('src', data.qrCodeUrl).removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');
                                $('#property_video_qr_placeholder').addClass('d-none');
                                // Reveal the Scan Me heading row (may be hidden when VideoQRCodeUrl was null on page load)
                                // Defect 102485: Remove d-none (Bootstrap) in addition to calling .show()
                                $('#property_video_qr_heading').removeClass('d-none').show();
                                // Prefer server-provided qrCodeDownloadUrl (same-origin proxy). If absent,
                                // build the proxy URL client-side from qrCodeUrl so the anchor is always enabled.
                                var qrDownload = (data.qrCodeDownloadUrl && data.qrCodeDownloadUrl.length > 0)
                                    ? data.qrCodeDownloadUrl
                                    : ($('#prefixurl').val() || '') + '/download-file?url=' + encodeURIComponent(data.qrCodeUrl) + '&filename=ScanMePage_QR';
                                $('[download="VideoQRCode"]').attr('href', qrDownload).removeClass('disabled').css('pointer-events', '');
                            }

                            $('#instructions-div').addClass('d-none');
                        },
                        // On timeout
                        function(videoType) {
                            $('#instructions-div p').text('Unable to generate customized video. Please try again.').addClass('upload-error');
                        },
                        // On error
                        function(error) {
                            console.error('Property video error:', error);

                            // Hide loading spinner
                            $('#property_video_loading').addClass('d-none');

                            // Show error message with actual Cloudinary error
                            var errorText = error.errorMessage || 'Unable to generate customized video. Please try again.';
                            $('#instructions-div').removeClass('d-none');
                            $('#instructions-div p').text(errorText).addClass('upload-error');

                            // Remove pending class
                            $('#property_video').removeClass('pending');

                            // Hide QR code loading spinner if present
                            $('#property_video_qr_loading').addClass('d-none');
                        }
                    );
                }

                if ($('#social_video').is('.pending')) {
                    // Register social video handler
                    videoStatusHub.registerVideoHandler(
                        'social',
                        // On success
                        function(data) {
                            // Validate data before updating UI (check for ERROR prefix)
                            if (!data.videoUrl || !data.thumbnailUrl) {
                                console.warn('Social video data incomplete:', data);
                                $('#social_video_loading').addClass('d-none');
                                $('#instructions-social-div').removeClass('d-none');
                                $('#instructions-social-div p').text('Video is still processing. Please refresh the page in a moment.').addClass('upload-info');
                                return;
                            }

                            // Check for ERROR strings in URLs
                            if (data.videoUrl.startsWith('ERROR:') || data.thumbnailUrl.startsWith('ERROR:')) {
                                console.error('Social video generation failed:', data);
                                $('#social_video_loading').addClass('d-none');
                                $('#instructions-social-div').removeClass('d-none');
                                $('#instructions-social-div p').text('Video generation encountered an error. Please contact support.').addClass('upload-error');
                                $('#social_video').removeClass('pending');
                                return;
                            }

                            // Update UI directly from SignalR data - no AJAX call needed!
                            var $thumbnail = $('#social_video [data-role="thumbnail"]');
                            $thumbnail.attr('data-src', data.thumbnailUrl);
                            $thumbnail.css('background-image', 'url("' + data.thumbnailUrl + '")');

                            $('#social_video [data-role="play-button"]').attr('href', data.videoUrl);
                            $('#social_video').removeClass('pending');
                            $('#social_video_loading').addClass('d-none');

                            // Set download URL if provided
                            if (data.downloadUrl) {
                                $('[download="SocialVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                                $('[download="SocialVideo"]').parent().removeClass('d-none');
                            }

                            new VideoPlayer();

                            $('#instructions-social-div').addClass('d-none');
                        },
                        // On timeout
                        function(videoType) {
                            $('#instructions-social-div p').text('Unable to generate social video. Please try again.').addClass('upload-error');
                        },
                        // On error
                        function(error) {
                            console.error('Social video error:', error);

                            // Hide loading spinner
                            $('#social_video_loading').addClass('d-none');

                            // Show error message with actual Cloudinary error
                            var errorText = error.errorMessage || 'Unable to generate social video. Please try again.';
                            $('#instructions-social-div').removeClass('d-none');
                            $('#instructions-social-div p').text(errorText).addClass('upload-error');

                            // Remove pending class
                            $('#social_video').removeClass('pending');
                        }
                    );
                }

                if ($('#social_ad_video').is('.pending')) {
                    // Register social ad video handler
                    videoStatusHub.registerVideoHandler(
                        'social_ad',
                        // On success
                        function(data) {
                            // Validate data before updating UI (check for ERROR prefix)
                            if (!data.videoUrl || !data.thumbnailUrl) {
                                console.warn('Social ad video data incomplete:', data);
                                $('#social_ad_video_loading').addClass('d-none');
                                $('#instructions-social_ad-div').removeClass('d-none');
                                $('#instructions-social_ad-div p').text('Video is still processing. Please refresh the page in a moment.').addClass('upload-info');
                                return;
                            }

                            // Check for ERROR strings in URLs
                            if (data.videoUrl.startsWith('ERROR:') || data.thumbnailUrl.startsWith('ERROR:')) {
                                console.error('Social ad video generation failed:', data);
                                $('#social_ad_video_loading').addClass('d-none');
                                $('#instructions-social_ad-div').removeClass('d-none');
                                $('#instructions-social_ad-div p').text('Video generation encountered an error. Please contact support.').addClass('upload-error');
                                $('#social_ad_video').removeClass('pending');
                                return;
                            }

                            // Update UI directly from SignalR data - no AJAX call needed!
                            var $thumbnail = $('#social_ad_video [data-role="thumbnail"]');
                            $thumbnail.attr('data-src', data.thumbnailUrl);
                            $thumbnail.css('background-image', 'url("' + data.thumbnailUrl + '")');

                            $('#social_ad_video [data-role="play-button"]').attr('href', data.videoUrl);
                            $('#social_ad_video').removeClass('pending');
                            $('#social_ad_video_loading').addClass('d-none');

                            // Set download URL if provided
                            if (data.downloadUrl) {
                                $('[download="SocialAdVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                                $('[download="SocialAdVideo"]').parent().removeClass('d-none');
                            }

                            new VideoPlayer();

                            $('#instructions-social_ad-div').addClass('d-none');
                        },
                        // On timeout
                        function(videoType) {
                            $('#instructions-social_ad-div p').text('Unable to generate social ad video. Please try again.').addClass('upload-error');
                        },
                        // On error
                        function(error) {
                            console.error('Social ad video error:', error);

                            // Hide loading spinner
                            $('#social_ad_video_loading').addClass('d-none');

                            // Show error message with actual Cloudinary error
                            var errorText = error.errorMessage || 'Unable to generate social ad video. Please try again.';
                            $('#instructions-social_ad-div').removeClass('d-none');
                            $('#instructions-social_ad-div p').text(errorText).addClass('upload-error');

                            // Remove pending class
                            $('#social_ad_video').removeClass('pending');
                        }
                    );
                }

                handlersRegistered = true;
            }

            // Helper function to register all document handlers (Flyer, Certificate, QR Code)
            function registerDocumentHandlers() {
                if (!videoStatusHub) return;

                // Register QR code handler
                videoStatusHub.registerDocumentHandler('qr_code',
                    // onSuccess
                    function (data) {
                        if (data.documentUrl) {
                            var cacheBuster = new Date().getTime();
                            var qrPreviewUrl = data.documentUrl.replace(".pdf", ".png") + "?cb=" + cacheBuster;
                            // Use same-origin proxy for download — fl_attachment is cross-origin and causes
                            // the browser to navigate instead of triggering Save-As.
                            var prefixUrl = $('#prefixurl').val() || '';
                            var qrDownloadUrl = prefixUrl + '/download-file?url=' + encodeURIComponent(data.documentUrl) + '&filename=QRCode';
                            // Swap spinner → real image
                            $("#qr-placeholder").hide();
                            $("#qr-img").attr("src", qrPreviewUrl).show();
                            // Enable download link
                            $("#qr-download").attr("href", qrDownloadUrl).removeClass("disabled").css('pointer-events', '');
                            qrRegenerating = false;
                            $qrImg.data("qr-regenerating", false);
                        }
                    },
                    // onTimeout
                    function () {
                        console.warn('QR Code generation timed out');
                        $("#qr-placeholder").html('<div style="text-align:center;padding:20px;"><p style="font-weight:bold;margin:0;">QR Code Unavailable</p><p style="font-size:0.9em;margin:5px 0 0 0;">Generation timed out. Please refresh the page.</p></div>');
                    },
                    // onError
                    function (error) {
                        console.error('QR Code generation error:', error);
                        var errorText = (error && error.errorMessage) || 'Unable to generate QR code. Please try again.';
                        $("#qr-placeholder").html('<div style="text-align:center;padding:20px;"><p style="font-weight:bold;margin:0;">QR Code Unavailable</p><p style="font-size:0.9em;margin:5px 0 0 0;">' + errorText + '</p></div>');
                    }
                );

                // Register flyer handler
                videoStatusHub.registerDocumentHandler('flyer',
                    // onSuccess
                    function (data) {
                        if (data.documentUrl) {
                            var cacheBuster = new Date().getTime();
                            var flyerPreviewUrl = data.documentUrl.replace(".pdf", ".png") + "?cb=" + cacheBuster;
                            // Hide server-side spinner div, show real image
                            $("#flyer-placeholder").hide();
                            $("#openimg").attr("src", flyerPreviewUrl).show();
                            // Use same-origin proxy for download so browser triggers Save-As
                            var flyerSignalRProxyUrl = ($('#prefixurl').val() || '') + '/download-file?url=' + encodeURIComponent(data.documentUrl) + '&filename=OpenHouseFlyer';
                            $("#openlink").attr("href", flyerSignalRProxyUrl).removeClass("disabled").css('pointer-events', '');
                            // M4: update closure so polling stops checking for flyer after SignalR delivers
                            flyerRegenerating = false;
                            $openimg.data("flyer-regenerating", false);
                        }
                    },
                    // onTimeout
                    function () {
                        console.warn('Flyer generation timed out');
                        $("#openimg").attr("src", "");
                        $("#openlink").addClass("disabled").attr("href", "javascript:void(0)").text("Flyer unavailable – please refresh");
                    },
                    // onError
                    function (error) {
                        console.error('Flyer generation error:', error);
                        var errorText = (error && error.errorMessage) || 'Unable to generate flyer. Please try again.';
                        $("#openimg").attr("src", "");
                        $("#openlink").addClass("disabled").attr("href", "javascript:void(0)").text(errorText);
                    }
                );

                // Certificate is handled by direct AJAX on page load (not SignalR).
                // No handler registered here — the button is never replaced by a spinner.
            }

            // Solution 1: Check for pending videos or documents and initialize SignalR
            if ($('#property_video').is('.pending') || $('#social_video').is('.pending') || $('#social_ad_video').is('.pending') || flyerRegenerating || qrRegenerating) {
                // SOLUTION 1 - STEP 1: Create SignalR instance (but don't connect yet)
                createVideoSignalR();

                // SOLUTION 1 - STEP 2: Register handlers BEFORE connection/subscription
                registerVideoHandlers();
                registerDocumentHandlers();

                // SOLUTION 1 - STEP 3: Now initialize the connection and subscribe
                initializeVideoSignalRConnection()
                    .then(() => {
                        // Phase 2: Start polling fallback after 30 seconds if SignalR hasn't delivered
                        setTimeout(startPollingFallback, 30000);
                    })
                    .catch((error) => {
                        console.error('SignalR initialization failed, items will need manual refresh:', error);
                        // Start polling immediately if SignalR fails
                        startPollingFallback();
                    });
            }

            // Phase 2 Solution 2: Database polling fallback
            var pollingInterval = null;

            function startPollingFallback() {
                if (pollingInterval) {
                    return;
                }
                var pollDelay = 10000; // Start at 10s
                var maxDelay = 60000;  // Max 60s between polls
                var maxRetries = 12;   // ~5 minutes total
                var retryCount = 0;
                var consecutiveErrors = 0;

                function poll() {
                    var hasPendingVideos = $('#property_video.pending, #social_video.pending, #social_ad_video.pending').length > 0;
                    var hasPendingDocuments = flyerRegenerating;
                    var hasPending = hasPendingVideos || hasPendingDocuments;

                    if (!hasPending || retryCount >= maxRetries) {
                        pollingInterval = null;
                        return;
                    }

                    retryCount++;
                    $.ajax({
                        url: window.location.pathname + '/get-video-status',
                        type: 'GET',
                        data: { confirmationNumber: confirmationNumber },
                        timeout: 15000,
                        success: function(response) {
                            consecutiveErrors = 0;
                            pollDelay = 10000; // Reset delay on success
                            if (response) {
                                updateAssetsFromPolling(response);
                            }
                            pollingInterval = setTimeout(poll, pollDelay);
                        },
                        error: function(xhr, status, error) {
                            consecutiveErrors++;
                            console.warn('Polling failed (attempt ' + retryCount + ', consecutive errors: ' + consecutiveErrors + '):', error);
                            // Exponential backoff: double delay on each consecutive error, cap at maxDelay
                            pollDelay = Math.min(pollDelay * 2, maxDelay);
                            pollingInterval = setTimeout(poll, pollDelay);
                        }
                    });
                }

                pollingInterval = setTimeout(poll, pollDelay);
            }

            function updateAssetsFromPolling(response) {
                // Update property video if ready and still pending
                if (response.propertyVideo && $('#property_video').is('.pending')) {
                    updateVideoUI('property', response.propertyVideo);
                }

                // Update social video if ready and still pending
                if (response.socialVideo && $('#social_video').is('.pending')) {
                    updateVideoUI('social', response.socialVideo);
                }

                // Update social ad video if ready and still pending
                if (response.socialAdVideo && $('#social_ad_video').is('.pending')) {
                    updateVideoUI('social_ad', response.socialAdVideo);
                }

                // Update flyer if ready
                if (response.flyerUrl && flyerRegenerating) {
                    var flyerPollingProxyUrl = loc1 + '/download-file?url=' + encodeURIComponent(response.flyerUrl) + '&filename=OpenHouseFlyer';
                    $("#openlink").attr("href", flyerPollingProxyUrl).removeClass("disabled").css('pointer-events', '');
                    var cacheBuster = new Date().getTime();
                    var flyerPreviewUrl = response.flyerUrl.replace(".pdf", ".png") + "?cb=" + cacheBuster;
                    $("#openimg").attr("src", flyerPreviewUrl);
                    flyerRegenerating = false;
                    $openimg.data("flyer-regenerating", false);
                }

                // Certificate is handled by direct AJAX on page load — no polling needed
            }

            function updateVideoUI(videoType, data) {
                // Skip if video URL starts with ERROR
                if (data.videoUrl && data.videoUrl.startsWith('ERROR:')) {
                    console.warn(videoType + ' video has error:', data.videoUrl);
                    $('#' + videoType + '_video').removeClass('pending');
                    $('#' + videoType + '_video_loading').addClass('d-none');
                    return;
                }

                // Skip if thumbnail URL starts with ERROR
                if (data.thumbnailUrl && data.thumbnailUrl.startsWith('ERROR:')) {
                    console.warn(videoType + ' thumbnail has error:', data.thumbnailUrl);
                    $('#' + videoType + '_video').removeClass('pending');
                    $('#' + videoType + '_video_loading').addClass('d-none');
                    return;
                }

                if (videoType === 'property') {
                    var $thumbnail = $('#property_video [data-role="thumbnail"]');
                    
                    // Only update video/thumb if they are not Pending
                    if (data.videoUrl && data.videoUrl !== 'Pending') {
                        var cacheBuster = new Date().getTime();
                        var finalThumbnail = data.thumbnailUrl;
                        if (finalThumbnail && !finalThumbnail.includes('?')) {
                            finalThumbnail += '?cb=' + cacheBuster;
                        } else if (finalThumbnail) {
                            finalThumbnail += '&cb=' + cacheBuster;
                        }

                        if (finalThumbnail) {
                            $thumbnail.attr('data-src', finalThumbnail);
                            $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');
                        }

                        $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                        $('#property_video').removeClass('pending');
                        $('#property_video_loading').addClass('d-none');
                        $('#instructions-div').addClass('d-none');
                        
                        if (data.downloadUrl) {
                            $('[download="CustomVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                            $('[download="CustomVideo"]').parent().removeClass('d-none');
                        }
                        
                        new VideoPlayer();
                    }

                    if (data.videoQrCodeUrl) {
                        $('#property_video_qr').attr('src', data.videoQrCodeUrl).removeClass('d-none');
                        $('#property_video_qr_loading').addClass('d-none');
                        $('#property_video_qr_placeholder').addClass('d-none');
                        $('#property_video_qr_heading').removeClass('d-none').show();
                        // Prefer server-provided qrCodeDownloadUrl (same-origin proxy). If absent,
                        // build the proxy URL client-side from videoQrCodeUrl so the anchor is always enabled.
                        var qrDownloadFallback = (data.qrCodeDownloadUrl && data.qrCodeDownloadUrl.length > 0)
                            ? data.qrCodeDownloadUrl
                            : ($('#prefixurl').val() || '') + '/download-file?url=' + encodeURIComponent(data.videoQrCodeUrl) + '&filename=ScanMePage_QR';
                        $('[download="VideoQRCode"]').attr('href', qrDownloadFallback).removeClass('disabled').css('pointer-events', '');
                    }
                } else if (videoType === 'social') {
                    var $thumbnail = $('#social_video [data-role="thumbnail"]');
                    var cacheBuster = new Date().getTime();
                    var finalThumbnail = data.thumbnailUrl;
                    if (finalThumbnail && !finalThumbnail.includes('?')) {
                        finalThumbnail += '?cb=' + cacheBuster;
                    } else if (finalThumbnail) {
                        finalThumbnail += '&cb=' + cacheBuster;
                    }

                    $thumbnail.attr('data-src', finalThumbnail);
                    $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                    $('#social_video [data-role="play-button"]').attr('href', data.videoUrl);
                    $('#social_video').removeClass('pending');
                    $('#social_video_loading').addClass('d-none');
                    $('#instructions-social-div').addClass('d-none');

                    if (data.downloadUrl) {
                        $('[download="SocialVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                        $('[download="SocialVideo"]').parent().removeClass('d-none');
                    }

                    new VideoPlayer();
                } else if (videoType === 'social_ad') {
                    var $thumbnail = $('#social_ad_video [data-role="thumbnail"]');
                    var cacheBuster = new Date().getTime();
                    var finalThumbnail = data.thumbnailUrl;
                    if (finalThumbnail && !finalThumbnail.includes('?')) {
                        finalThumbnail += '?cb=' + cacheBuster;
                    } else if (finalThumbnail) {
                        finalThumbnail += '&cb=' + cacheBuster;
                    }

                    $thumbnail.attr('data-src', finalThumbnail);
                    $thumbnail.css('background-image', 'url("' + finalThumbnail + '")');

                    $('#social_ad_video [data-role="play-button"]').attr('href', data.videoUrl);
                    $('#social_ad_video').removeClass('pending');
                    $('#social_ad_video_loading').addClass('d-none');
                    $('#instructions-social_ad-div').addClass('d-none');

                    if (data.downloadUrl) {
                        $('[download="SocialAdVideo"]').attr('href', data.downloadUrl).removeClass('disabled').css('pointer-events', '');
                        $('[download="SocialAdVideo"]').parent().removeClass('d-none');
                    }

                    new VideoPlayer();
                }
            }

            // Clean up SignalR connection and polling when leaving page
            $(window).on('beforeunload', function() {
                if (videoStatusHub) {
                    videoStatusHub.stop();
                }
                if (pollingInterval) {
                    clearInterval(pollingInterval);
                }
            });

            if ($('#reorder_signrider').length) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap2';
                script.async = true;
                document.body.appendChild(script);

                $('[data-toggle="tooltip"]').tooltip();

                $('#reorder_signrider').on('click', function () {
                    $('#signrider_reorder_dialog').addClass('show');
                });

                // Issue #403: the dialog posts from a visible Address / Address 2 / City /
                // State / Zip form, filled either by picking a Google suggestion (via the
                // 'addresspicked' event GinitMap2 raises) or by typing it in. Address 2 is
                // optional; the other four are required.
                var reorderRequired = '#reorder_line1, #reorder_city, #reorder_state, #reorder_zip';
                var reorderFields = '#reorder_line1, #reorder_line2, #reorder_city, #reorder_state, #reorder_zip';
                var reorderParts = '#street_number, #route, #locality, #administrative_area_level_1, #postal_code';

                function openReorderForm() {
                    $('#reorder_address_fields').removeClass('d-none');
                    $('#reorder_manual_link').addClass('d-none');
                }

                function resetReorderForm() {
                    $(reorderFields).val('').removeClass('blank-error');
                    $(reorderParts).val('');
                    // Clear the visible box too, or reopening shows a valid-looking
                    // address whose fields have been wiped and which will be rejected.
                    $('#autocomplete').val('');
                    $('#reorder_address_fields').addClass('d-none');
                    $('#reorder_manual_link').removeClass('d-none');
                }

                // Keep the search box showing what will actually be posted. Setting the
                // value programmatically fires no 'input' event, so this cannot trip the
                // clear-on-typing handler below.
                function syncReorderSearchBox() {
                    var line1 = $.trim($('#reorder_line1').val());
                    var line2 = $.trim($('#reorder_line2').val());
                    var cityStateZip = [$.trim($('#reorder_city').val()),
                        [$('#reorder_state').val() || '', $.trim($('#reorder_zip').val())].filter(Boolean).join(' ')]
                        .filter(Boolean).join(', ');
                    $('#autocomplete').val([[line1, line2].filter(Boolean).join(' '), cityStateZip].filter(Boolean).join(', '));
                }

                $('#reorder_manual_link').on('click', openReorderForm);

                $('#autocomplete').on('addresspicked', function () {
                    $('#reorder_line1').val([$('#street_number').val(), $('#route').val()].filter(Boolean).join(' '));
                    $('#reorder_line2').val('');
                    $('#reorder_city').val($('#locality').val());
                    $('#reorder_state').val($('#administrative_area_level_1').val());
                    $('#reorder_zip').val($('#postal_code').val());
                    openReorderForm();
                    $('#address_form_error').addClass('d-none');

                    // A suggestion Google could not fully resolve (e.g. no street number)
                    // leaves holes; point at them so the LO finishes it by hand.
                    var filled = $(reorderFields).filter(function () { return !!$(this).val(); }).length;
                    $(reorderRequired).each(function () {
                        $(this).toggleClass('blank-error', filled > 0 && !$(this).val());
                    });
                });

                $(reorderFields).on('keyup change', function () {
                    var $this = $(this);

                    if ($this.is(reorderRequired)) {
                        $this.toggleClass('blank-error', !$this.val());
                    }

                    if (!$(reorderRequired).filter(function () { return !$(this).val(); }).length) {
                        $('#address_form_error').addClass('d-none');
                    }

                    syncReorderSearchBox();
                });

                $('#signrider_newaddress').on('change', function () {
                    $('#signrider_address_form').toggleClass('active');
                    $('.pac-container').css('z-index', '10001');
                });

                $('#cancel_reorder').on('click', function () {
                    $('#address_form_error, #signrider_order_error').addClass('d-none');

                    resetReorderForm();

                    $('#signrider_reorder_dialog').removeClass('show');

                    $("#signrider_newaddress").prop("checked", false);
                    $('#signrider_address_form').removeClass('active');
                });

                $('#confirm_reorder').on('click', function () {
                    $('#signrider_order_error').addClass('d-none');

                    // Anything posted here overwrites the delivery address stored on
                    // the order, so when the user has not opted into a new address we
                    // must post nothing at all and leave the stored value alone.
                    var postData = {};

                    if ($('#signrider_newaddress').is(':checked')) {
                        var line1 = $.trim($('#reorder_line1').val());
                        var line2 = $.trim($('#reorder_line2').val());
                        var city = $.trim($('#reorder_city').val());
                        var state = $('#reorder_state').val() || '';
                        var zip = $.trim($('#reorder_zip').val());

                        if (!line1 || !city || !state || !zip) {
                            // Address 2 is optional and is never an error when blank.
                            openReorderForm();
                            $(reorderRequired).each(function () {
                                $(this).toggleClass('blank-error', !$(this).val());
                            });
                            $('#address_form_error')
                                .text('Please provide a valid mailing address')
                                .removeClass('d-none');
                            return;
                        }

                        postData = { line1, line2, city, state, zip };
                    }

                    $.post({
                        url: "reorder-sign-rider?confirmation=" + $('#hdnConfirmationNumber').val(),
                        data: postData,
                        beforeSend: function () {
                            $('.dialog-content, .dialog-buttons').addClass('d-none');
                            $('.dialog-loading').removeClass('d-none');
                        }
                    })
                    .done(function () {
                        $('#success_message, #close_reorder').removeClass('d-none');
                        $('#cancel_reorder, #confirm_reorder').addClass('d-none');
                        $('.dialog-content').children().not('#success_message').addClass('d-none');
                    })
                    .fail(function (xhr) {
                        $('#address_error').removeClass('d-none');
                        $('#signrider_order_error').removeClass('d-none').children().first().text(xhr.status === 400
                            ? 'Please provide a valid mailing address'
                            : 'Unable to place new sign rider order. Please try again.');
                    })
                    .always(function () {
                        $('.dialog-content, .dialog-buttons').removeClass('d-none');
                        $('.dialog-loading').addClass('d-none');
                    });
                });

                $('#autocomplete').bind("cut copy paste", function (e) {
                    e.preventDefault();
                });

                // Typing in the search box starts a new address. The form fields and the
                // hidden parts still hold the PREVIOUS one, so without this the reorder
                // would submit an address the LO can no longer see and believes they replaced.
                // Google sets the input value programmatically, which fires no 'input'
                // event, so this cannot clobber a selection it just made.
                $('#autocomplete').on('input', function () {
                    $(reorderFields).val('').removeClass('blank-error');
                    $(reorderParts).val('');
                });

                $('#close_reorder').on('click', function () {
                    $('#signrider_reorder_dialog').removeClass('show');
                    $('#reorder_signrider').parent().addClass('d-none');
                });
            }           
        });
    }
});